import { ButtonHTMLAttributes } from 'react';
import { ArrowRight } from 'lucide-react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
    loading?: boolean;
    showArrow?: boolean;
};

export default function AuthPrimaryButton({
    children,
    loading,
    showArrow = true,
    className = '',
    disabled,
    ...rest
}: Props) {
    return (
        <button
            type="submit"
            disabled={disabled || loading}
            className={`inline-flex w-full items-center justify-center gap-2 rounded-[14px] bg-gradient-to-r from-[#7A2F78] via-ryd-primary to-[#E05AAE] px-5 py-3.5 text-[15px] font-semibold text-white shadow-md transition hover:scale-[1.01] disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
            {...rest}
        >
            {loading ? 'Processing…' : children}
            {!loading && showArrow ? <ArrowRight size={16} /> : null}
        </button>
    );
}
